export default __webpack_public_path__ + "static/media/ab-logo.d4b03fed.svg";